export default "__VITE_ASSET__DUn1Ehpa__"